export const SET_ADM_MEMBER_STATISTICS_LOADING = "SET_ADM_MEMBER_STATISTICS_LOADING"
export const SET_ADM_MEMBER_STATISTICS_SUCCESS = "SET_ADM_MEMBER_STATISTICS_SUCCESS"
export const SET_ADM_MEMBER_STATISTICS_ERROR = "SET_ADM_MEMBER_STATISTICS_ERROR"
export const SET_ADM_MEMBER_STATISTICS_RESULT = "SET_ADM_MEMBER_STATISTICS_RESULT"

export const GET_MEMBER_STATISTICS_INFO = "GET_MEMBER_STATISTICS_INFO"
export const GET_MEMBER_STATISTICS_INFO_SUCCESS = "GET_MEMBER_STATISTICS_INFO_SUCCESS"

export const GET_MEMBER_ACTIVITY_INFO = "GET_MEMBER_ACTIVITY_INFO"
export const GET_MEMBER_ACTIVITY_INFO_SUCCESS = "GET_MEMBER_ACTIVITY_INFO_SUCCESS"

export const GET_ADDED_CONTACTS_INFO = "GET_ADDED_CONTACTS_INFO"
export const GET_ADDED_CONTACTS_INFO_SUCCESS = "GET_ADDED_CONTACTS_INFO_SUCCESS"

export const GET_DELETED_CONTACTS_INFO = "GET_DELETED_CONTACTS_INFO"
export const GET_DELETED_CONTACTS_INFO_SUCCESS = "GET_DELETED_CONTACTS_INFO_SUCCESS"
export const SET_CONTACTS_LOG = "SET_CONTACTS_LOG"

export const GET_ADMIN_LIST = "GET_ADMIN_LIST"
export const GET_ADMIN_LIST_SUCCESS = "GET_ADMIN_LIST_SUCCESS"

export const UPDATE_SALES_OWNER = "UPDATE_SALES_OWNER"
export const UPDATE_SALES_OWNER_SUCCESS = "UPDATE_SALES_OWNER_SUCCESS"

export const GET_STARRED_ENTITIES_INFO = "GET_STARRED_ENTITIES_INFO"
export const GET_STARRED_ENTITIES_INFO_SUCCESS = "GET_STARRED_ENTITIES_INFO_SUCCESS"

export const GET_HIDDEN_ENTITIES_INFO = "GET_HIDDEN_ENTITIES_INFO"
export const GET_HIDDEN_ENTITIES_INFO_SUCCESS = "GET_HIDDEN_ENTITIES_INFO_SUCCESS"
export const SET_ENTITIES_STAR_HIDE_LOG = "SET_ENTITIES_STAR_HIDE_LOG"
